module.exports = __webpack_public_path__ + "img/mashup.1f622cb7.jpeg";